import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const QuoteIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue244'}</MuiIcon>
        );
    })